import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class EmployeePayrollService {

  constructor(private http: HttpClient) { }

  getEmployeePayrolls() {
    return this.http.get<any>(Library.API_ENDPOINT + 'employee-payroll/get_employee_payroll', OPTIONS);
  }

  createUpdatePayroll(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `employee-payroll/save_update_payroll`, elementForm, OPTIONS);
  }

  createUpdatePayrollLine(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `employee-payroll/save_update_payroll_line`, elementForm, OPTIONS);
  }

  deletePayroll(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `employee-payroll/delete_payroll/${id}`, OPTIONS);
  }

  deletePayrollLine(selectedIds: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `employee-payroll/delete_payroll_line`, selectedIds, OPTIONS);
  }
}
